import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

/**
 * Generate PDF for inspection report from HTML element
 * @param {HTMLElement} element - The HTML element to convert to PDF
 * @param {Object} inspection - Inspection data for filename
 */
export const generateInspectionPDF = async (inspection) => {
  try {
    // Find the print sheet element
    const printElement = document.getElementById('inspection-print-sheet');
    
    if (!printElement) {
      throw new Error('Print sheet element not found');
    }

    // Wait a bit for any images to load
    await new Promise(resolve => setTimeout(resolve, 500));

    // Convert to canvas with high quality
    const canvas = await html2canvas(printElement, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
      width: printElement.scrollWidth,
      height: printElement.scrollHeight,
      windowWidth: printElement.scrollWidth,
      windowHeight: printElement.scrollHeight
    });

    // Calculate PDF dimensions (A4: 210mm x 297mm)
    const imgWidth = 210; // A4 width in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    // Create PDF
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgData = canvas.toDataURL('image/png', 1.0);

    // Add image to PDF
    let heightLeft = imgHeight;
    let position = 0;
    const pageHeight = 297; // A4 height in mm

    // Add first page
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Add additional pages if content is longer than one page
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    // Generate filename
    const plateNo = inspection.plate_no?.replace(/\s+/g, '_') || 'inspection';
    const date = new Date(inspection.inspection_date || Date.now());
    const dateStr = date.toISOString().split('T')[0];
    const filename = `Inspection_${plateNo}_${dateStr}.pdf`;

    // Save PDF
    pdf.save(filename);

    return { success: true, filename };
  } catch (error) {
    console.error('Error generating PDF:', error);
    throw error;
  }
};

export const generateInspectionPDFBlob = async (inspection) => {
  const printElement = document.getElementById('inspection-print-sheet');
  if (!printElement) throw new Error('Print sheet element not found');

  await new Promise(resolve => setTimeout(resolve, 500));

  const canvas = await html2canvas(printElement, {
    scale: 2,
    useCORS: true,
    logging: false,
    backgroundColor: '#ffffff',
    width: printElement.scrollWidth,
    height: printElement.scrollHeight,
    windowWidth: printElement.scrollWidth,
    windowHeight: printElement.scrollHeight,
  });

  const imgWidth = 210;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;
  const pdf = new jsPDF('p', 'mm', 'a4');
  const imgData = canvas.toDataURL('image/png', 1.0);

  let heightLeft = imgHeight;
  let position = 0;
  const pageHeight = 297;

  pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    position = heightLeft - imgHeight;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  return pdf.output('blob');
};

